import React from 'react'
import MagazineHtml from '../../components/renderers/MagazineHtml'

type Props = {
  title: string
  subtitle: string
  format?: 'micro' | 'zine' | 'book' | 'event' | 'job'
  previewImage: string | undefined | null
  portraitImage?: string | null
  landscapeImage?: string | null
  publishAlt?: string | undefined
  html?: string
}

export default function PreviewPanel({
  title,
  subtitle,
  format = 'zine',
  previewImage,
  portraitImage,
  landscapeImage,
  publishAlt,
  html,
}: Props) {
  const watermarkLabel =
    format === 'micro'
      ? 'PIXE \u2022 MICRO'
      : format === 'event'
      ? 'PIXE \u2022 EVENT'
      : format === 'job'
      ? 'PIXE \u2022 JOB'
      : format === 'zine'
      ? 'PIXE \u2022 ZINE'
      : 'PIXE'
  const effectivePortrait = portraitImage || landscapeImage || null
  const effectiveLandscape = landscapeImage || portraitImage || null
  const coverSrc = previewImage || effectivePortrait || effectiveLandscape || null
  const readerImage = effectiveLandscape || effectivePortrait || null
  return (
    <div className="sticky top-24 space-y-6">
      <div className="rounded-[28px] border border-white/15 bg-white/5 overflow-hidden relative shadow-2xl aspect-[3/4]">
        {coverSrc ? (
          <img src={coverSrc} alt={publishAlt || 'Cover preview'} className="absolute inset-0 h-full w-full object-cover" />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-white/40 text-sm">Cover not generated yet</div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent pointer-events-none" />
        <div className="absolute top-6 left-6 text-xs uppercase tracking-[0.3em] text-white/70">{watermarkLabel}</div>
        <div className="absolute bottom-6 left-6 right-6 text-white space-y-2">
          <div className="text-sm uppercase tracking-[0.3em] text-white/60">Feature</div>
          <h2 className="text-3xl font-bold leading-tight">{title || 'Cover title'}</h2>
          <p className="text-white/80 text-sm">{subtitle || 'Add a subtitle to see it here.'}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 text-xs text-white/70">
        <div className="rounded-xl border border-white/10 bg-white/5 overflow-hidden">
          <div className="px-3 py-2">Portrait</div>
          {effectivePortrait ? (
            <img src={effectivePortrait} alt="Portrait cover" className="w-full h-32 object-cover" />
          ) : (
            <div className="h-32 flex items-center justify-center text-white/30">No portrait yet</div>
          )}
        </div>
        <div className="rounded-xl border border-white/10 bg-white/5 overflow-hidden">
          <div className="px-3 py-2">Landscape (16:9)</div>
          {effectiveLandscape ? (
            <img src={effectiveLandscape} alt="Landscape cover" className="w-full h-32 object-cover" />
          ) : (
            <div className="h-32 flex items-center justify-center text-white/30">Auto-crop pendingâ€¦</div>
          )}
        </div>
      </div>

      <div>
        <div className="text-sm text-white/60 mb-2">Reader Preview</div>
        <div className="rounded-xl border border-white/10 overflow-hidden">
          {readerImage && (
            <img src={readerImage} alt={publishAlt || 'Cover'} className="w-full h-44 md:h-56 object-cover" />
          )}
          <div className="p-4">
            <h2 className="text-xl font-bold tracking-tight">{title || 'Title'}</h2>
            {subtitle && <p className="mt-1 text-white/80">{subtitle}</p>}
          </div>
          {html && (
            <article className="px-4 pb-4">
              <MagazineHtml surface="postPreview" html={html} />
            </article>
          )}
        </div>
      </div>
    </div>
  )
}
